import { IPlayUIStateProps } from "../..";
import { IFooterMapDispatchProps, IFooterMapStateProps } from "./Footer";

export const sharedMapPropsToState = (
  state: IPlayUIStateProps
): IFooterMapStateProps => ({
  hidden: state.keypad.hidden,
  gameName: state.gameInformation.gameName,
  gameProducer: state.gameInformation.gameProducer,
  clockAvailable: state.footer.clockAvailable,
  clockDate: state.footer.clockDate,
  isPlayingForFun: state.keypad.isPlayingForFun
});

export const sharedMapDispatchToProps = (
  dispatch
): IFooterMapDispatchProps => ({});
